import { showToast } from 'vant'
import { get_web } from '../request/index'
import YSF from '@neysf/qiyu-web-sdk'

export default {
    // pay-cashier 小程序 appid（拉起小程序收银台用）
    payCashierAppid: 'wxa3a0c431638480b7',

    // pay-cashier 小程序原始ID（gh_ 开头，小程序后台「设置→基础设置→账号信息」可查）
    // 开放标签按后端文档方案优先用 username，查到后填入即可；留空则回落 appid 方式
    payCashierUsername: '',

    // 拉起的小程序版本：trial=体验版（联调期），小程序正式上线后改为 release
    payCashierEnvVersion: 'release',

    // 获取当前登录用户的真实用户 ID（登录态下取 userInfo 中的数字 ID，兼容 Base64 编码还原）
    getRealUserId() {
        const user = this.getUser()
        if (user && Object.keys(user).length > 0) {
            const candidates = [user.sid_new, user.id, user.user_id, user.uid, user.sid]
            for (const i in candidates) {
                const val = candidates[i]
                if (val !== undefined && val !== null && val !== '') {
                    const str = String(val).trim()
                    if (/^\d+$/.test(str)) return str
                    // 若为 Base64 字符串（如 MTAxMjcx 解出 101271），还原为真实数字 ID
                    try {
                        const decoded = typeof atob === 'function' ? atob(str) : ''
                        if (/^\d+$/.test(decoded)) return decoded
                    } catch (e) {}
                }
            }
            const direct = user.sid_new || user.id || user.user_id || user.sid
            if (direct) return direct
        }
        return ''
    },

    // 构建拉起小程序收银台的路径查询参数。
    // 签名由商城服务端完成，这里必须原样带上 sign/timestamp/nonce/extra_params，不能改值、不能重排 extra_params。
    buildMiniappPayQuery(params) {
        if (!params) return ''
        const parts = []
        const keys = Object.keys(params)
        for (const i in keys) {
            const k = keys[i]
            const v = params[k]
            if (v === undefined || v === null || v === '') continue
            let text
            if (typeof v === 'object') {
                text = JSON.stringify(v)
            } else {
                text = String(v).replace(/`/g, '')
            }
            parts.push(k + '=' + encodeURIComponent(text))
        }
        return parts.join('&')
    },

    // 获取站点信息
    async getWeb() {
        var web = sessionStorage.getItem('web')
        if (web) {
            const webData = JSON.parse(web)
            if (typeof webData === 'object' && webData !== null) {
                return webData
            } else {
                return null
            }
        } else {
            const response = await get_web()
            if (response && response.data && typeof response.data === 'object') {
                sessionStorage.setItem('web', JSON.stringify(response.data))
                return response.data
            } else {
                return null
            }
        }
    },

    // 客服
    async service(type) {
        const userAgent = navigator.userAgent.toLowerCase()
        const user = this.getUser()

        if (userAgent.includes('micromessenger') && (!user.sid || !user.sid_new)) {
            return showToast('请先微信登录...')
        }

        if (typeof ysf === 'function' || typeof window.ysf === 'function') {
            return this.qiyuService(type)
        }

        showToast('正在初始化，请稍后...')

        const initSuccess = await this.initQiyuWithRetry()
        initSuccess ? this.qiyuService(type) : showToast('抱歉，出错了！请重启程序再尝试')
    },

    // 获取用户信息
    getUser() {
        try {
            return JSON.parse(sessionStorage.getItem('userInfo')) || {}
        } catch {
            return {}
        }
    },

    // 初始化七鱼客服（带重试机制和超时）
    // @param {number} retries - 重试次数，默认2次
    // @returns {Promise<boolean>} - 初始化是否成功
    initQiyuWithRetry(retries = 2) {
        return new Promise(resolve => {
            const tryInit = (attempt) => {
                if (attempt <= 0) return resolve(false)
                
                const timeout = setTimeout(() => {
                    tryInit(attempt - 1)
                }, 5000)
                
                YSF.init('a1b7a98d2d60abc0cee2c3d0cf621c9f', { hidden: 1 }).then(() => {
                    clearTimeout(timeout)
                    resolve(true)
                }).catch(() => {
                    clearTimeout(timeout)
                    tryInit(attempt - 1)
                })
            }
            tryInit(retries)
        })
    },

    // 打开七鱼客服
    qiyuService(type) {
        var web = sessionStorage.getItem('web')
        var user = sessionStorage.getItem('userInfo')
        try {
            web = JSON.parse(web) || {}
            user = JSON.parse(user) || {}
        } catch {
            web = {}
            user = {}
        }
        ysf('config', {
            uid: user.sid || this.useDeviceId(),
            data: JSON.stringify([
                { key: 'real_name', value: user.sid_new ? `${user.sid_new}-${user.nick_name}` : '游客' },
                { index: 0, key: 'tags', label: '标签', value: `${web.web_name}${user.business_name ? ',' + user.business_name : ''}` },
                { key: 'avatar', label: '头像', value: web.web_logo }
            ]),
            success: function() {
                if (type == 'full') {
                    // 客服页面
                    location.href = ysf('url')
                } else {
                    // 当前页面拉起
                    ysf('open')
                }
            },
            error: function() {
              
            }
        })
    },

    // 获取游客唯一标识
    useDeviceId() {
        let deviceId = localStorage.getItem('DEVICE_ID')
        if (!deviceId) {
            deviceId = Math.floor(Math.random() * 9000000000) + 1000000000
            localStorage.setItem('DEVICE_ID', deviceId)
        }
        return deviceId
    },

    // 判断微信环境
    isWeiXin() {
        const userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('micromessenger') > -1) {
            return true
        }
        return false
    },

    // 判断移动设备
    isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    },

    // 微信授权次数记录 key
    wxAuthCountKey: 'wx_auth_count',

    // 发起微信授权跳转（带次数限制，防止连续失败死循环；返回是否已发起跳转）
    wxAuthorize() {
        let appId = ''
        try {
            appId = JSON.parse(sessionStorage.getItem('web') || '{}').appId || ''
        } catch (e) {
            appId = ''
        }
        if (!appId) {
            return false
        }
        const count = Number(sessionStorage.getItem(this.wxAuthCountKey) || 0)
        if (count >= 2) {
            sessionStorage.removeItem(this.wxAuthCountKey)
            showToast('微信登录失败，请稍后重试')
            return false
        }
        sessionStorage.setItem(this.wxAuthCountKey, String(count + 1))
        const redirectUri = encodeURIComponent(window.location.origin)
        const scope = 'snsapi_userinfo'
        const state = 'STATE'
        // 等待1秒，确保页面加载完成  千万别删
        setTimeout(() => {
            window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&state=${state}#wechat_redirect`
        }, 1000)
        return true
    },

    // 重置微信授权次数（登录成功后调用）
    resetWxAuthCount() {
        sessionStorage.removeItem(this.wxAuthCountKey)
    },

    // 判断app环境
    isApp() {
        const userAgent = navigator.userAgent.toLowerCase()
        if (userAgent.indexOf('htmlsdk') > -1) {
            return true
        }
        return false
    },

    // 判断android和ios
    isAndroidIos() {
        const userAgent = navigator.userAgent.toLowerCase()
        if (/android/.test(userAgent)) {
            return 'android'
        } else if (/iphone|ipad|ipod/.test(userAgent)) {
            return 'ios'
        }
        return false
    },

    // 判断苹果手机的Safari浏览器
    isIosSafari() {
        const userAgent = navigator.userAgent.toLowerCase()
        if (/iphone|ipad|ipod/.test(userAgent)) {
            if (userAgent.indexOf('safari') > -1 && 
                userAgent.indexOf('chrome') === -1 && 
                userAgent.indexOf('crios') === -1 && 
                userAgent.indexOf('fxios') === -1 && 
                userAgent.indexOf('htmlsdk') === -1) {
                return true
            }
        }
        return false
    }
}